import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Response } from "@angular/http";
import { Router, ActivatedRoute } from "@angular/router";
import { APIService } from "../../services/login/api";
import { BehaviorSubject } from "rxjs/Rx";

interface ResetPasswordForm {
  oldPassword: string;
  newPassword: string;
  newPasswordValidation: string;
}

export interface ResetPasswordErrorResponseBody {
  errors: Array<string>;
  method: string;
  uri: string;
}

@Component({
  selector: "reset-password",
  template: require("./reset-password.component.html"),
  styles: [require("./reset-password.component.scss")],
  encapsulation: ViewEncapsulation.None
})
export class ResetPasswordComponent implements OnInit {
  public form: ResetPasswordForm;

  public errorMessage: BehaviorSubject<string> = new BehaviorSubject("");

  private _mail: string = "";

  public constructor(
    private apiSvc: APIService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute
  ) {
    this.form = {
      oldPassword: "",
      newPassword: "",
      newPasswordValidation: "" // has to be equal to new password (to prevent user mistakes)
    };
  }

  public ngOnInit() {
    let self = this;
    const EMAIL_PARAM: string = "email";

    // in case user tries to enter this screen directly by url and by a login request - navigate to login screen
    this._activatedRoute.params.subscribe(params => {
      if (typeof params[EMAIL_PARAM] === "undefined") {
        this._router.navigate(["./"]);
      } else {
        self._mail = params[EMAIL_PARAM];
      }
    });
  }

  public onSubmit() {
    let self = this;
    this.apiSvc
      .resetPassword(this.form.oldPassword, this.form.newPassword, this._mail)
      .subscribe(
        (res: Response) => {
          self._router.navigate(["./"]);
        },
        (err: Response) => {
          switch (err.status) {
            case 403: //in case user tries to reset to one of its 5 last passwords
              self.errorMessage.next(
                "This password has used before, Please provide a new password"
              );
              break;
            case 401: //in correct old password
              self.errorMessage.next("Old password is wrong");
              break;
            case 400: //new password's pattern doesn't fit to our passwords policy
              self.errorMessage.next(
                (<ResetPasswordErrorResponseBody>err.json()).errors.reduce(
                  (accumulator, value) => {
                    return accumulator + "\n" + value;
                  },
                  ""
                )
              );
              break; //sum reasons of invalid new password to one string text
            default:
              self.errorMessage.next("Reset password failed");
              break;
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/reset-password/reset-password.component.ts